import ParentView from "../framework/ParentView";
import { PageIds } from "../PageIds";
import UpgradeTabItemView from "./UpgradeTabItemView";
import Page from "../framework/Page";
import View from "../framework/View";

export default class PrimaryUpgradeTabBar extends ParentView {
    /**
     * @param {string} parentId
     */
    constructor(parentId) {
        super(parentId, PageIds.PRIMARY_UPGRADE_PANEL_TAB_BAR);

        /**
         * @constant
         * @private
         * @type {Array.<UpgradeTabItemView>}
         */
        this.tabItemViews = [];

        // Let the underlying view code know that this view is visible and should remain visible.
        this.setViewVisible(true);
        this.setCurrentlyVisible(false);
    }

    /**
     * @param {View} tabContentsView 
     * @param {string} tabIconPath
     */
    addPanelView(tabContentsView, tabIconPath) {
        const tabId = tabContentsView.elementId + '_tab';
        const tabItemView = new UpgradeTabItemView(this.elementId, tabId, tabContentsView, this, tabIconPath);

        this.tabItemViews.push(tabItemView);

        this.addView(tabItemView);
    }

    /**
     * @override
     */
    initializeView() {

        //   <div id="primaryUpgradePanelTabBar" class="upgrade-tab-menu-bar">
        //     <button id="minedUpgradesMenuItem" class="upgrade-tab-menu-item-selected"><img src="images/pick_40x40.png"/></button>
        //     <button id="pickUpgradesMenuItem" class="upgrade-tab-menu-item"><img src="images/pick_40x40.png"/></button>
        //     <button id="pointUpgradesMenuItem" class="upgrade-tab-menu-item"><img src="images/pick_40x40.png"/></button>
        //     <button id="menuPanelMenuItem" class="upgrade-tab-menu-item"><img src="images/pick_40x40.png"/></button>
        //     <div class="upgrade-tab-menu-bar-fill-remaining"></div>
        //   </div>

        const parentElement = Page.getElement(this.parentId);
        const primaryUpgradeTabBar = Page.createElement('div', parentElement, this.getElementId(), 'upgrade-tab-menu-bar');

        super.initializeView();

        // After we have initialized the child views (by calling super.initializeView()), we need to add the spacer:

        // <div class="upgrade-tab-menu-bar-fill-remaining"></div>

        Page.createElement('div', primaryUpgradeTabBar, null, 'upgrade-tab-menu-bar-fill-remaining');

        // Make the 1st tab visible.
        if (this.tabItemViews.length > 0) {
            this.onTabItemViewClicked(this.tabItemViews[0]);
        }
    }

    /**
     * Invoked by the TabItemView when it is clicked.
     * @param {UpgradeTabItemView} tabItemView The tab item that was clicked
     */
    onTabItemViewClicked(tabItemView) {
        // hide current view, display new view
        for (let i = 0; i < this.tabItemViews.length; i++) {
            const currentTabItemView = this.tabItemViews[i];
            const tabSelected = currentTabItemView === tabItemView;

            currentTabItemView.setTabSelected(tabSelected);
            currentTabItemView.tabContentsView.setViewVisible(tabSelected);
        }
    }

    /**
     * Returns the value that the display property should be set to in order to make
     * the element visible. 
     * 
     * By default this is 'block', but you should overwrite this if the element is 'display:flex', or 'display:inline-block' 
     * or something other than 'display:block'.
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'flex';
    }

}